import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { hasAccess } from '../../utils/permissionHelper';
import { FaCog, FaFileAlt, FaChevronDown, FaBox } from 'react-icons/fa';

const Sidebar = () => {
  const location = useLocation();
  const isActive = path => location.pathname === path;
  const user = JSON.parse(localStorage.getItem("user"));
  const role = localStorage.getItem("role");
  const checkRole = localStorage.getItem("checkRole");
  const [settingOpen, setSettingOpen] = useState(false);

  const handleSettingClick = (e) => {
    e.preventDefault();
    setSettingOpen((prev) => !prev);
  };

  return (
    <div data-simplebar className="h-100">
      <div id="sidebar-menu">
        <ul className="metismenu list-unstyled" id="side-menu">

          <li className="menu-title"></li>

          {checkRole === "SuperAdmin" ? (
            <>
              <li className={isActive("/dashboard") ? 'mm-active' : ''}>
                <NavLink to="/dashboard" className="waves-effect">
                  <i className="mdi mdi-view-dashboard"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>
              {hasAccess(user, "Solar Partners") && (
                <li className={isActive("/dashboard/solar") ? 'mm-active' : ''}>
                  <NavLink to="/dashboard/solar" className="waves-effect nav-solar-link">
                  <i className="fas fa-paw paw"></i>
                    <span>Solar Partners</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Subscription") && (
                <li className={isActive("/dashboard/subscription") ? 'mm-active' : ''}>
                  <NavLink to="/dashboard/subscription" className="waves-effect">
                    <i className="fas fa-store-alt"></i>
                    <span>Subscription</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Billing") && (
                <li className={isActive("/dashboard/billing") ? 'mm-active' : ''}>
                  <NavLink to="/dashboard/billing" className="waves-effect">
                    <i className="fas fa-file-invoice-dollar"></i>
                    <span>Billing</span>
                  </NavLink>
                </li>
              )}
              <li className={isActive("/dashboard/setting") ? 'mm-active' : ''}>
                <NavLink to="/dashboard/setting" className="waves-effect">
                  <i className="dripicons-gear"></i>
                  <span>Master</span>
                </NavLink>
              </li>
              {hasAccess(user, "Support Ticket") && (
                    <li className={isActive("/dashboard/supportTicket") ? 'mm-active' : ''}>
                      <NavLink to="/dashboard/supportTicket" className="waves-effect">
                        <i className="fas fa-ticket-alt"></i>
                        <span>Support Ticket</span>
                      </NavLink>
                    </li>
                  )}
              <li>
                <a
                  href="#"
                  className="has-arrow waves-effect"
                  aria-expanded={settingOpen}
                  onClick={handleSettingClick}
                >
                 <i className="dripicons-gear"></i>
                  <span>Setting</span>
                </a>
                <ul
                  className="sub-menu mm-collapse"
                  aria-expanded={settingOpen}
                  style={{
                    height: settingOpen ? "auto" : "0px",
                    overflow: "hidden",
                    transition: "height 0.3s"
                  }}
                >
                  <li className={isActive("/dashboard/userRole") ? 'mm-active' : ''}>
                    <NavLink to="/dashboard/userRole" className="waves-effect">
                      <span className="dot me-1"></span>
                      <span>User & Role</span>
                    </NavLink>
                  </li>
                  
                </ul>
              </li>
            </>
          ) : (
            <>
              {/* USER DASHBOARD - permission-based visibility */}
              <li className={isActive("/user") ? 'mm-active' : ''}>
                <NavLink to="/user" className="waves-effect">
                  <i className="mdi mdi-view-dashboard"></i>
                  <span>Dashboard</span>
                </NavLink>
              </li>
              {hasAccess(user, "Lead") && (
                <li className={isActive("/user/followup") ? 'mm-active' : ''}>
                  <NavLink to="/user/followup" className="waves-effect">
                   <i className="fas fa-clock"></i>
                    <span>FollowUP</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Lead", ["Followup"]) && (
                <li className={isActive("/user/lead") ? 'mm-active' : ''}>
                  <NavLink to="/user/lead" className="waves-effect">
                   <i className="fas fa-user-friends"></i>
                    <span>Lead</span>
                  </NavLink>
                </li>
              )}
              
              {hasAccess(user, "Lead Visit Settings") && (
                <li className={isActive("/user/visit") ? 'mm-active' : ''}>
                  <NavLink to="/user/visit" className="waves-effect">
                  <i className="fas fa-map-marker-alt"></i>
                    <span>Lead Visit</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Item") && (
                <li className={isActive("/user/item") ? 'mm-active' : ''}>
                  <NavLink to="/user/item" className="waves-effect">
                  <i className="fas fa-th"></i>
                    <span>Item</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "ItemBom") && (
                <li className={isActive("/user/bom") ? 'mm-active' : ''}>
                  <NavLink to="/user/bom" className="waves-effect">
                  <i className="fas fa-calendar-alt"></i>
                  <span>BOM</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Quatation") && (
                <li className={isActive("/user/quotation") ? 'mm-active' : ''}>
                  <NavLink to="/user/quotation" className="waves-effect">
                    <i className="fas fa-file-invoice"></i>
                    <span>Quotation</span>
                  </NavLink>
                </li>
              )}
              {hasAccess(user, "Quatation") && (
                <li className={isActive("/user/supportTicket1") ? 'mm-active' : ''}>
                  <NavLink to="/user/supportTicket1" className="waves-effect">
                    <i className="fas fa-ticket-alt"></i>
                    <span>Support Ticket</span>
                  </NavLink>
                </li>
              )}
              {/* Setting submenu */}
              <li>
                <a
                  href="#"
                  className="has-arrow waves-effect"
                  aria-expanded={settingOpen}
                  onClick={handleSettingClick}
                >
                  <i className="dripicons-gear"></i>
                  <span>Setting</span>
                </a>
                <ul
                  className="sub-menu mm-collapse"
                  aria-expanded={settingOpen}
                  style={{
                    height: settingOpen ? "auto" : "0px",
                    overflow: "hidden",
                    transition: "height 0.3s"
                  }}
                >
                  {hasAccess(user, "User") && (
                    <li className={isActive("/user/userRole") ? "mm-active" : ""}>
                      <NavLink to="/user/userRole" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>User & Role</span>
                      </NavLink>
                    </li>
                  )}
                  {(
                    hasAccess(user, "Project Settings") ||
                    hasAccess(user, "Lead Source Settings") ||
                    hasAccess(user, "Deal Type Settings") ||
                    hasAccess(user, "Deal Stage Settings") ||
                    hasAccess(user, "Deal Temperature Settings")
                  ) && (
                    <li className={isActive("/user/leadManage") ? "mm-active" : ""}>
                      <NavLink to="/user/leadManage" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>Lead Manage</span>
                      </NavLink>
                    </li>
                  )}
                  {hasAccess(user, "Item") && (
                    <li className={isActive("/user/itemManage") ? "mm-active" : ""}>
                      <NavLink to="/user/itemManage" className="waves-effect">
                         <span className="dot me-1"></span>
                        <span>Item Manage</span>
                      </NavLink>
                    </li>
                  )}
                  
                  {hasAccess(user, "Quatation-Setting") && (
                    <li className={isActive("/user/generalSetting") ? "mm-active" : ""}>
                      <NavLink to="/user/generalSetting" className="waves-effect">
                        <span className="dot me-1"></span>
                        <span>General Setting</span>
                      </NavLink>
                    </li>
                  )}
                  
                  {hasAccess(user, "Quatation-Setting") && (
                    <li className={isActive("/user/quotationSetting") ? "mm-active" : ""}>
                      <NavLink to="/user/quotationSetting" className="waves-effect">
                         <span className="dot me-1 mb-1"></span>
                        <span>Quotation Setting</span>
                      </NavLink>
                    </li>
                  )}
                </ul>
              </li>
              {/* Uncomment if needed
              <li className={isActive("/user/currancy") ? 'mm-active' : ''}>
                <NavLink to="/user/currancy" className="waves-effect">
                  <span className="dot me-1"></span>
                  <span>Currency Setting</span>
                </NavLink>
              </li>
              */}
            </>
          )}
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;